import React from "react";
import "./EditPersonalInfo.scss";
import {
  Flex,
  Radio,
  Modal,
  Toast,
  ActivityIndicator,
  ImagePicker,
  DatePicker,
  Button,
  Picker,
  List,
  InputItem,
  WhiteSpace,
} from "antd-mobile";

import { createForm } from "rc-form";
import WXVoiceInput from "../../components/WXVoiceInput";
import arrayTreeFilter from "array-tree-filter";
import http from "../../util/api";
import GoBack from "../../components/GoBack";
import SignatureCanvas from "react-signature-canvas";
import withAuth from "../../HOCs/withAuth";
import { getRegions } from "../../util/util";
import mic from "../../components/WXVoiceInput/mic.png";
import lrz from "lrz";

const resid = "617650212793"; //人员信息表
const residOther = "617653213160"; //其他信息表
const residSelf = "617653226103"; //自我评价表
const residEdu = "617653178957"; //学历信息表
const residWork = "617653190856"; //工作经历信息表
const residFam = "617653202060"; //家庭关系表
const alert = Modal.alert;
const judgePhone = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;

const curDate = new Date();
// 照片数据
const data = [];
// interface State{
//     trimmedDataURL:string
// }

class EditPersonalInfo extends React.Component {
  // 删除教育信息
  removeEdu = async (index) => {
    let delEduRe;
    let flagDel = toString(this.state.data[index].REC_ID) || "";
    console.log(flagDel.length);
    console.log(this.state.data[index]);

    if (flagDel.length > 0) {
      try {
        delEduRe = await http().removeRecords({
          resid: residEdu,
          data: [this.state.data[index]],
        });
      } catch (e) {
        console.log(e);
      }
    }
  };
  // 删除职业信息
  removeJob = async (index) => {
    let delWorkRe;
    let flagDel = toString(this.state.data2[index].REC_ID) || "";
    console.log(this.state.data2[index]);
    if (flagDel.length > 0) {
      try {
        delWorkRe = await http().removeRecords({
          resid: residWork,
          data: [this.state.data2[index]],
        });
      } catch (e) {
        console.log(e);
      }
    }
  };
  // 删除家庭信息
  removeFam = async (index) => {
    let delFamRe;
    let flagDel = toString(this.state.data3[index].REC_ID) || "";

    if (flagDel.length > 0) {
      try {
        delFamRe = await http().removeRecords({
          resid: residFam,
          data: [this.state.data3[index]],
        });
      } catch (e) {
        console.log(e);
      }
    }
  };
  // 获取后台已有的信息数据
  getRec = async (id) => {
    let userCode = JSON.parse(localStorage.getItem("userInfo")).UserCode;
    let intervieweeId;
    let res;
    let resSelf;
    let resOthers;
    let resEdu;
    let resWork;
    let resFam;

    try {
      res = await http().getTable({
        resid: resid,
        // cmswhere: `ID= '${userCode}'`
      });
      console.log("主表信息", res.data.data[0]);
      // 判断本地有无更新
      let newTime =
        localStorage.getItem("editInfoTime") || "999-08-01 00:00:00";
      let oldTime = res.data.data[0].REC_EDTTIME;
      let startTmp = oldTime
        .replace(" ", ":")
        .replace(/\:/g, "-")
        .split("-");
      let endTmp = newTime
        .replace(" ", ":")
        .replace(/\:/g, "-")
        .split("-");
      let sd = new Date(
        startTmp[0],
        startTmp[1],
        startTmp[2],
        startTmp[3],
        startTmp[4],
        startTmp[5]
      );
      let ed = new Date(
        endTmp[0],
        endTmp[1],
        endTmp[2],
        endTmp[3],
        endTmp[4],
        endTmp[5]
      );
      if (sd.getTime() >= ed.getTime()) {
        // 先把数据存到state和localstorage
        this.setState({ userInfo: res.data.data[0] });
        localStorage.setItem("personalInfo", JSON.stringify(res.data.data[0]));
        intervieweeId = res.data.data[0].intervieweeId;
        var _bloodType = this.sTA(this.state.userInfo.bloodType);
        this.setState({
          userInfo: { ...this.state.userInfo, bloodType: _bloodType },
        });

        var _hasJob = this.sTA(this.state.userInfo.hasJob);
        this.setState({
          userInfo: { ...this.state.userInfo, hasJob: _hasJob },
        });

        var _naition = this.sTA(this.state.userInfo.naition);
        this.setState({
          userInfo: { ...this.state.userInfo, naition: _naition },
        });

        var _religion = this.sTA(this.state.userInfo.religion);
        this.setState({
          userInfo: { ...this.state.userInfo, religion: _religion },
        });

        var _nativePlace = this.sTA(this.state.userInfo.nativePlace);
        this.setState({
          userInfo: { ...this.state.userInfo, nativePlace: _nativePlace },
        });

        var _sex = this.sTA(this.state.userInfo.sex);
        this.setState({ userInfo: { ...this.state.userInfo, sex: _sex } });

        var _homeAddress = this._sTA(this.state.userInfo.homeAddress);
        this.setState({
          userInfo: { ...this.state.userInfo, homeAddress: _homeAddress },
        });

        var _address = this._sTA(this.state.userInfo.address);
        this.setState({
          userInfo: { ...this.state.userInfo, address: _address },
        });

        var _emgAddress = this._sTA(this.state.userInfo.emgAddress);
        this.setState({
          userInfo: { ...this.state.userInfo, emgAddress: _emgAddress },
        });

        // 个人照片
        let _photoLInk = [];
        if (res.data.data[0].photoLInk) {
          _photoLInk = [{ url: res.data.data[0].photoLInk, id: 1 }];
        }
        this.setState({
          userInfo: { ...this.state.userInfo, photoLInk: _photoLInk },
        });
        if (_photoLInk.length > 0) {
          this.setState({
            ["photoLInk"]: [{ url: res.data.data[0].photoLInk }],
          });
        }
        // 其他信息表ID
        try {
          resOthers = await http().getTable({
            resid: residOther,
          });
          if (resOthers.data.data.length > 0) {
            this.setState({ data4: resOthers.data.data[0] });

            var _health = this.sTA(this.state.data4.health);
            this.setState({ data4: { ...this.state.data4, health: _health } });

            var _microscope = this.sTA(this.state.data4.microscope);
            this.setState({
              data4: { ...this.state.data4, microscope: _microscope },
            });

            var _suit = this.sTA(this.state.data4.suit);
            this.setState({ data4: { ...this.state.data4, suit: _suit } });

            // var _pregnant=this.sTA(this.state.data4.pregnant)
            // this.setState({data4:{...this.state.data4, suit: _pregnant}})
          }
        } catch (error) {
          console.log(error);
        }
        // 自我评价表
        try {
          resSelf = await http().getTable({
            resid: residSelf,
            // cmswhere: `InterviewerId= '${intervieweeId}'`
          });
          if (resSelf.data.data.length > 0) {
            this.setState({ data5: resSelf.data.data[0] });
            var _computer = this.sTA(this.state.data5.computer);
            this.setState({
              data5: { ...this.state.data5, computer: _computer },
            });

            var _English = this.sTA(this.state.data5.English);
            this.setState({
              data5: { ...this.state.data5, English: _English },
            });

            var _microscope2 = this.sTA(this.state.data5.microscope);
            this.setState({
              data5: { ...this.state.data5, microscope: _microscope2 },
            });

            var _assemble = this.sTA(this.state.data5.assemble);
            this.setState({
              data5: { ...this.state.data5, assemble: _assemble },
            });

            var _welding = this.sTA(this.state.data5.welding);
            this.setState({
              data5: { ...this.state.data5, welding: _welding },
            });

            var _autoTool = this.sTA(this.state.data5.autoTool);
            this.setState({
              data5: { ...this.state.data5, autoTool: _autoTool },
            });

            var _package = this.sTA(this.state.data5.package);
            this.setState({
              data5: { ...this.state.data5, package: _package },
            });

            var _material = this.sTA(this.state.data5.material);
            this.setState({
              data5: { ...this.state.data5, material: _material },
            });

            var _measure = this.sTA(this.state.data5.measure);
            this.setState({
              data5: { ...this.state.data5, measure: _measure },
            });

            var _chemi = this.sTA(this.state.data5.chemi);
            this.setState({ data5: { ...this.state.data5, chemi: _chemi } });
          }
        } catch (error) {
          console.log(error);
        }

        // 教育经历
        try {
          resEdu = await http().getTable({
            resid: residEdu,
          });

          if (resEdu.data.data.length > 0) {
            this.setState({ data: resEdu.data.data });
            var arrIns = [];
            var arrIns2 = [];
            var arrIns3 = [];
            var _num = 0;
            while (_num < this.state.data.length) {
              arrIns = this.sTA(this.state.data[_num].eduCertificate);
              let dataINS = this.state.data;
              dataINS[_num].eduCertificate = arrIns;
              arrIns2 = this.sTA(this.state.data[_num].schoolType);
              dataINS[_num].schoolType = arrIns2;
              arrIns3 = this.sTA(this.state.data[_num].eduBg);
              dataINS[_num].eduBg = arrIns3;

              this.setState({ data: dataINS });

              _num++;
            }
          }
        } catch (error) {
          console.log(error);
        }

        // 工作经历
        try {
          resWork = await http().getTable({
            resid: residWork,
          });

          if (resWork.data.data.length > 0) {
            this.setState({ data2: resWork.data.data });
            var arrIns = [];
            var _num = 0;
            while (_num < this.state.data2.length) {
              arrIns = this.sTA(this.state.data2[_num].quitType);
              let dataINS = this.state.data2;
              dataINS[_num].quitType = arrIns;
              this.setState({ data2: dataINS });
              _num++;
            }
          }
        } catch (error) {
          console.log(error);
        }

        // 家庭背景
        try {
          resFam = await http().getTable({
            resid: residFam,
          });

          if (resFam.data.data.length > 0) {
            this.setState({ data3: resFam.data.data });
            var arrIns = [];
            var _num = 0;
            while (_num < this.state.data3.length) {
              arrIns = this._sTA(this.state.data3[_num].address);
              let dataINS = this.state.data3;
              dataINS[_num].address = arrIns;
              this.setState({ data3: dataINS });
              _num++;
            }
          }
        } catch (error) {
          console.log(error);
        }

        Toast.hide();
      } else {
        this.setState({
          userInfo: JSON.parse(localStorage.getItem("personalInfo")) || "",
        });
        this.setState({
          userInfo: { ...this.state.userInfo, REC_ID: res.data.data[0].REC_ID },
        });

        var l = localStorage.getItem("eduInfo") || "null";
        if (l == "undefined") {
          l = "null";
        }
        if (l != "null") {
          this.setState({
            data: JSON.parse(localStorage.getItem("eduInfo")) || "",
          });
        }
        l = localStorage.getItem("workInfo") || "null";
        if (l == "undefined") {
          l = "null";
        }
        if (l != "null") {
          this.setState({
            data2: JSON.parse(localStorage.getItem("workInfo")) || "",
          });
        }
        l = localStorage.getItem("famInfo") || "null";
        if (l == "undefined") {
          l = "null";
        }
        if (l != "null") {
          this.setState({
            data3: JSON.parse(localStorage.getItem("famInfo")) || "",
          });
        }
        l = localStorage.getItem("otherInfo") || "null";
        if (l == "undefined") {
          l = "null";
        }
        if (l != "null") {
          this.setState({
            data4: JSON.parse(localStorage.getItem("otherInfo")) || "",
          });
        }
        l = localStorage.getItem("selfInfo") || "null";
        if (l == "undefined") {
          l = "null";
        }
        if (l != "null") {
          this.setState({
            data5: JSON.parse(localStorage.getItem("selfInfo")) || "",
          });
        }

        // 个人照片
        let photoURL = localStorage.getItem("photoLink") || "";
        if (photoURL.length > 0) {
          let _photoLInk = photoURL ? [{ url: photoURL, id: 1 }] : [];
          this.setState({
            userInfo: { ...this.state.userInfo, photoLInk: _photoLInk },
          });
          this.setState({ ["photoLInk"]: [{ url: photoURL }] });
        }

        Toast.hide();
        Toast.info("上次编辑的数据未成功提交", 1);
      }

      // if(res.ErrorMsg === ""){
      // }
    } catch (error) {
      console.log("错误信息", error);
      // 错误的场合读取本地数据
      // Toast.info('网络异常，当前仅可保存本地数据，不可提交数据',2);
      this.setState({
        userInfo: JSON.parse(localStorage.getItem("personalInfo")) || "",
      });
      var l = localStorage.getItem("eduInfo") || "null";
      if (l == "undefined") {
        l = "null";
      }
      if (l != "null") {
        this.setState({
          data: JSON.parse(localStorage.getItem("eduInfo")) || "",
        });
      }
      l = localStorage.getItem("workInfo") || "null";
      if (l == "undefined") {
        l = "null";
      }
      if (l != "null") {
        this.setState({
          data2: JSON.parse(localStorage.getItem("workInfo")) || "",
        });
      }
      l = localStorage.getItem("famInfo") || "null";
      if (l == "undefined") {
        l = "null";
      }
      if (l != "null") {
        this.setState({
          data3: JSON.parse(localStorage.getItem("famInfo")) || "",
        });
      }
      l = localStorage.getItem("otherInfo") || "null";
      if (l == "undefined") {
        l = "null";
      }
      if (l != "null") {
        this.setState({
          data4: JSON.parse(localStorage.getItem("otherInfo")) || "",
        });
      }
      l = localStorage.getItem("selfInfo") || "null";
      if (l == "undefined") {
        l = "null";
      }
      if (l != "null") {
        this.setState({
          data5: JSON.parse(localStorage.getItem("selfInfo")) || "",
        });
      }

      // 个人照片
      let photoURL = localStorage.getItem("photoLink") || "";
      if (photoURL.length > 0) {
        let _photoLInk = photoURL ? [{ url: photoURL, id: 1 }] : [];
        this.setState({
          userInfo: { ...this.state.userInfo, photoLInk: _photoLInk },
        });
        this.setState({ ["photoLInk"]: [{ url: photoURL }] });
      }

      Toast.hide();
    }
  };
  fixIOSWXBug() {
    document.body.scrollTop = 0;
  }
  // 记录更新时间
  editInfoTime() {
    var date = new Date();
    var seperator1 = "-";
    var seperator2 = ":";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate =
      date.getFullYear() +
      seperator1 +
      month +
      seperator1 +
      strDate +
      " " +
      date.getHours() +
      seperator2 +
      date.getMinutes() +
      seperator2 +
      date.getSeconds();
    localStorage.setItem("editInfoTime", currentdate);
  }
  // 更新本地个人信息数据
  refreshLocal() {
    this.editInfoTime();
    localStorage.setItem("personalInfo", JSON.stringify(this.state.userInfo));
  }
  // 检查某页是数据是否已经填完
  checkPage(arr) {
    let checkstr = "";
    let i = 0;
    let flagCheck = false;
    while (i < arr.length) {
      checkstr = this.state.userInfo[arr[i]] || "";
      if (checkstr.length == 0) {
        console.log(arr[i], "没有");
        var info = "";

        if (arr[i] == "name") {
          info = "姓名";
        } else if (arr[i] == "hasJob") {
          info = "是否在职";
        } else if (arr[i] == "sex") {
          info = "性别";
        } else if (arr[i] == "bloodType") {
          info = "血型";
        } else if (arr[i] == "height") {
          info = "身高";
        } else if (arr[i] == "nativePlace") {
          info = "户籍";
        } else if (arr[i] == "naition") {
          info = "民族";
        } else if (arr[i] == "religion") {
          info = "宗教";
        } else if (arr[i] == "hobby") {
          info = "兴趣爱好";
        } else if (arr[i] == "homeAddress") {
          info = "家庭地址";
        } else if (arr[i] == "homeDetailAddress") {
          info = "家庭详址";
        } else if (arr[i] == "homePhone") {
          info = "家庭电话";
        } else if (arr[i] == "address") {
          info = "暂住地址";
        } else if (arr[i] == "detailAddress") {
          info = "暂住详址";
        } else if (arr[i] == "phone") {
          info = "暂住电话";
        } else if (arr[i] == "mobilephone") {
          info = "手机电话";
        } else if (arr[i] == "email") {
          info = "电子邮箱";
        } else if (arr[i] == "emergency") {
          info = "姓名";
        } else if (arr[i] == "emgRelation") {
          info = "关系";
        } else if (arr[i] == "emgUnit") {
          info = "工作单位";
        } else if (arr[i] == "emgJob") {
          info = "职务";
        } else if (arr[i] == "emgDetailAddress") {
          info = "家庭地址";
        } else if (arr[i] == "emgAddress") {
          info = "家庭详址";
        } else if (arr[i] == "emgPhone") {
          info = "联系电话";
        }
        Toast.info(info + "还没有填写", 1);
        return false;
      }
      i++;
    }
  }
  // 判断开始时间是否小于结束时间
  judgeTime(data) {
    var dataLength = data.length;
    var counter = 0;
    while (counter < dataLength) {
      var sT = new Date(data[counter].startTime);
      sT = sT.getTime();
      var eT = new Date(data[counter].endTime);
      eT = eT.getTime();
      if (sT > eT) {
        Toast.info("开始时间必须早于结束时间！", 1);
        return false;
      }
      counter++;
    }
  }

  // 电子签名
  sigCanvas = {
    clear: () => {},
    toDataURL: (param) => {
      return "";
    },
  };
  enlarge() {
    var el = document.getElementById("previewImg");
    if (el.classList.contains("enlarged") == false) {
      el.classList.add("enlarged");
    } else {
      el.classList.remove("enlarged");
    }
  }
  draw() {
    document.getElementById("previewImg").innerHTML = "";
    var n = 0;
    while (n < this.state.trimmedDataURL.length) {
      var ul = document.getElementById("previewImg"); //添加 img
      var img = document.createElement("img"); //设置 img 图片地址
      img.src = this.state.trimmedDataURL[n];

      ul.appendChild(img);
      n++;
    }
    var str = this.state.trimmedDataURL.join("[");
    localStorage.setItem("signature", str);
  }
  clear = () => {
    // var arr=this.state.trimmedDataURL.pop();
    let arr = this.state.trimmedDataURL;
    arr.pop();
    this.setState(
      {
        trimmedDataURL: arr,
      },
      this.draw
    );
  };
  clearAll = () => {
    this.setState(
      {
        trimmedDataURL: [],
      },
      this.draw
    );
  };
  trim() {
    //let trimmedCanvas = this.sigCanvas.getTrimmedCanvas();
    this.state.trimmedDataURL.push(this.sigCanvas.toDataURL("image/png"));
    this.sigCanvas.clear();
    this.draw();

    // this.setState({trimmedDataURL: this.sigCanvas.toDataURL('image/png')})
  }
  // 判断是否停笔
  time() {
    var flagTime = false;
    var t;
    this.refs.sig.addEventListener("touchstart", function(e) {
      flagTime = true;
      clearInterval(t);
    });
    this.refs.sig.addEventListener("touchend", function(e) {
      flagTime = false;
      t = setTimeout(function() {
        if (flagTime == false) {
          document.getElementById("add").click();
        }
      }, 1000);
    });
  }
  // 微信
  loading() {
    Toast.loading("数据读取中", 999999);
  }
  async componentDidMount() {
    // this.editInfoTime();
    window.V5CHAT("hideBtn");
    this.loading();
    this.getRec();
    this.time();
    await this.getWXConfig();
    window.wx.ready(() => {});
    window.wx.error((res) => {
      console.log("调用微信jsapi返回的状态2:", res.errMsg);
    });
  }

  getWXConfig = async () => {
    try {
      let res = await http().getWXConfig();
      if (res.data.error === 0) {
        let { data } = res.data;
        console.log(data.Timestamp, data.AppId, data.NonceStr, data.Signature);
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.AppId, // 必填，公众号的唯一标识
          timestamp: data.Timestamp, // 必填，生成签名的时间戳
          nonceStr: data.NonceStr, // 必填，生成签名的随机串
          signature: data.Signature, // 必填，签名，见附录1
          jsApiList: [
            "chooseImage",
            "startRecord", //新增api
            "stopRecord", //新增api
            "translateVoice", //新增api
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      } else {
        console.error("error:  " + res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  passVocalValue = (v, place, key) => {
    console.log(v);
    this.setState(
      { [key]: { ...this.state[key], [place]: v } },
      this.refreshLocal
    );
    this.setState({ voiceInputField: false });
  };
  passVVGroup = (v, place, key, index) => {
    console.log(v);
    let data = this.state[place];
    data[index][key] = v;
    this.setState({ place }, this.saveEdu);
  };
  constructor(props) {
    super(props);
    this.clear = this.clear.bind(this);
    this.trim = this.trim.bind(this);
    this.state = {
      voiceInputField: false,
      voiceInputField2: false,
      district: getRegions(),
      trimmedDataURL: [],
      page: 1,
      curDate: curDate,
      isLoading: false,
      photoLInk: [],
      userInfo: {
        name: "",
      },
      localIds: [""],
      // 学历信息
      data: [
        {
          startTime: "",
          endTime: "",
          school: "",
          major: "",
          schoolType: "",
          eduBg: "",
          eduCertificate: "",
        },
      ],
      // 工作信息
      data2: [
        {
          startTime: "",
          endTime: "",
          unit: "",
          job: "",
          boss: "",
          bossJob: "",
          bossPhone: "",
          quitReason: "",
          quitType: "",
        },
      ],
      // 家庭关系
      data3: [
        {
          name: "",
          relation: "",
          unit: "",
          job: "",
          address: "",
          phone: "",
        },
      ],
      //其他信息
      data4: [
        {
          health: "",
          illness: "",
          injury: "",
          // infectDise:'',
          // pregnant:'',
          microscope: "",
          chroDise: "",
          suit: "",
        },
      ],
      // 自我评价
      data5: [
        {
          computer: "",
          English: "",
          microscope: "",
          assemble: "",
          welding: "",
          autoTool: "",
          package: "",
          material: "",
          measure: "",
          chemi: "",
          eyeIllness: "",
          sight: "",
        },
      ],
    };
  }
  handleClick = () => {
    this.inputRef.focus();
  };
  // 数组转字符串
  aTS(arr) {
    if (typeof arr == "object") {
      return arr.join("");
    } else {
      return arr;
    }
  }
  // 字符串转数组
  sTA(str) {
    if (typeof str == "string") {
      var arr = [];
      arr.push(str);
      return arr;
    } else {
      return str;
    }
  }
  // 三级联动数组转字符串
  _aTS(arr) {
    if (typeof arr == "object") {
      return arr.join("【");
    } else {
      return arr;
    }
  }
  // 三级联动字符串转数组
  _sTA(str) {
    if (typeof str == "string") {
      var arr = [];
      arr = str.split("【");
      return arr;
    } else {
      return str;
    }
  }
  // 提交数据
  postData = async () => {
    localStorage.setItem("submit", "Y");
    Toast.loading("数据提交中", 999999);
    const _sex = this.aTS(this.state.userInfo.sex);
    const _hasJob = this.aTS(this.state.userInfo.hasJob);
    const _naition = this.aTS(this.state.userInfo.naition);
    const _nativePlace = this.aTS(this.state.userInfo.nativePlace);
    const _religion = this.aTS(this.state.userInfo.religion);
    const _bloodType = this.aTS(this.state.userInfo.bloodType);
    const _homeAddress = this._aTS(this.state.userInfo.homeAddress);
    const _address = this._aTS(this.state.userInfo.address);
    const _emgAddress = this._aTS(this.state.userInfo.emgAddress);

    const _health = this.aTS(this.state.data4.health);
    // const _pregnant=this.aTS(this.state.data4.pregnant);
    const _microscope = this.aTS(this.state.data4.microscope);
    const _suit = this.aTS(this.state.data4.suit);

    const _computer = this.aTS(this.state.data5.computer);
    const _English = this.aTS(this.state.data5.English);
    const _microscope2 = this.aTS(this.state.data5.microscope);
    const _assemble = this.aTS(this.state.data5.assemble);
    const _welding = this.aTS(this.state.data5.welding);
    const _autoTool = this.aTS(this.state.data5.autoTool);
    const _package = this.aTS(this.state.data5.package);
    const _material = this.aTS(this.state.data5.material);
    const _measure = this.aTS(this.state.data5.measure);
    const _chemi = this.aTS(this.state.data5.chemi);

    const _data = {
      data: [
        {
          resid: resid,
          maindata: {
            submit: "Y",
            intervieweeId: this.state.userInfo.intervieweeId,
            name: this.state.userInfo.name,
            sex: _sex,
            hasJob: _hasJob,
            // birthdate:this.state.userInfo.birthdate,
            nativePlace: _nativePlace,
            naition: _naition,
            height: this.state.userInfo.height,
            weight: this.state.userInfo.weight,
            bloodType: _bloodType,
            seniority: this.state.userInfo.seniority,
            religion: _religion,
            techTitle: this.state.userInfo.techTitle,
            ID: this.state.userInfo.ID,
            hobby: this.state.userInfo.hobby,
            job: this.state.userInfo.job,
            homeAddress: _homeAddress,
            homeDetailAddress: this.state.userInfo.homeDetailAddress,
            homePhone: this.state.userInfo.homePhone,

            address: _address,
            detailAddress: this.state.userInfo.detailAddress,
            phone: this.state.userInfo.phone,
            mobilephone: this.state.userInfo.mobilephone,
            email: this.state.userInfo.email,
            entryTime: this.state.userInfo.entryTime,
            emergency: this.state.userInfo.emergency,
            emgRelation: this.state.userInfo.emgRelation,
            emgUnit: this.state.userInfo.emgUnit,
            emgJob: this.state.userInfo.emgJob,
            emgAddress: _emgAddress,
            emgDetailAddress: this.state.userInfo.emgDetailAddress,
            emgPhone: this.state.userInfo.emgPhone,
            emgJob: this.state.userInfo.emgJob,
            photoLInk: this.state.userInfo.photoLInk[0].url,
            C3_618419447565: this.state.trimmedDataURL.join("【"),
            _state: "modified",
            _id: 1,
            REC_ID: this.state.userInfo.REC_ID,
          },
          subdata: [
            {
              resid: residOther,
              maindata: {
                chroDise: this.state.data4.chroDise,
                illness: this.state.data4.illness,
                injury: this.state.data4.injury,
                health: _health,
                // infectDise: this.state.data4.infectDise,
                // pregnant: _pregnant,
                microscope: _microscope,
                suit: _suit,
                _state: "editoradd",
                _id: 1,
                REC_ID: this.state.REC_ID,
              },
            },
            {
              resid: residSelf,
              maindata: {
                computer: _computer,
                English: _English,
                microscope: _microscope2,
                assemble: _assemble,
                welding: _welding,
                autoTool: _autoTool,
                package: _package,
                material: _material,
                measure: _measure,
                chemi: _chemi,
                eyeIllness: this.state.data5.eyeIllness,
                sight: this.state.data5.sight,
                _state: "editoradd",
                _id: 1,
                REC_ID: this.state.REC_ID,
              },
            },
          ],
        },
      ],
    };

    // 学历信息
    var _num = 0;
    while (_num < this.state.data.length) {
      this.state.data[_num]._id = _num + 1;
      this.state.data[_num]._state = "editoradd";
      this.state.data[_num].eduCertificate = this.aTS(
        this.state.data[_num].eduCertificate
      );
      this.state.data[_num].schoolType = this.aTS(
        this.state.data[_num].schoolType
      );
      this.state.data[_num].eduBg = this.aTS(this.state.data[_num].eduBg);

      var _eduObj = {
        resid: residEdu,
        maindata: this.state.data[_num],
      };
      _data.data[0].subdata.push(_eduObj);
      _num++;
    }
    // 职业经验
    _num = 0;
    while (_num < this.state.data2.length) {
      this.state.data2[_num]._id = _num + 1;
      this.state.data2[_num]._state = "editoradd";
      var _rec = this.state.data2[_num].REC_ID || "null";
      if (_rec.length == 0) {
        delete this.state.data2[_num].REC_ID;
      }
      this.state.data2[_num].quitType = this.aTS(
        this.state.data2[_num].quitType
      );
      var _eduObj = {
        resid: residWork,
        maindata: this.state.data2[_num],
      };
      _data.data[0].subdata.push(_eduObj);
      _num++;
    }
    // 家庭成员
    _num = 0;
    while (_num < this.state.data3.length) {
      this.state.data3[_num]._id = _num + 1;
      this.state.data3[_num]._state = "editoradd";
      var _rec = this.state.data3[_num].REC_ID || "null";
      if (_rec.length == 0) {
        delete this.state.data3[_num].REC_ID;
      }
      this.state.data3[_num].address = this._aTS(
        this.state.data3[_num].address
      );

      var _eduObj = {
        resid: residFam,
        maindata: this.state.data3[_num],
      };
      _data.data[0].subdata.push(_eduObj);
      _num++;
    }
    const res3 = await http().saveRecordAndSubTables(_data);
    try {
      if ((res3.data.message = "操作成功")) {
        Toast.hide();
        Toast.success("操作成功", 1);
        // this.props.history.go(-1);
        this.props.history.push("/personal_center");
      }
    } catch (error) {
      console.log(error);
      Toast.fail("error");
    }
    //   if(res3.data.message='操作成功'){
    // 	  Toast.hide();
    // 	  Toast.success('操作成功',1);

    // 	  this.props.history.push('/personal_center')
    //   }
  };

  // 控制页面是否显示
  pageShow = () => {
    document.getElementById("step1").classList.remove("hidden");
    document.getElementById("step2").classList.remove("hidden");
    document.getElementById("step3").classList.remove("hidden");
    document.getElementById("step4").classList.remove("hidden");
    document.getElementById("step5").classList.remove("hidden");
    document.getElementById("step6").classList.remove("hidden");
    document.getElementById("step7").classList.remove("hidden");
    document.getElementById("step8").classList.remove("hidden");
    document.getElementById("step9").classList.remove("hidden");

    document
      .getElementById("cur")
      .setAttribute(
        "style",
        "width:" + ((this.state.page - 1) / 8) * 100 + "%"
      );
    window.scrollTo(0, 0);
    if (this.state.page != 1) {
      document.getElementById("step1").classList.add("hidden");
    }
    if (this.state.page != 2) {
      document.getElementById("step2").classList.add("hidden");
    }
    if (this.state.page != 3) {
      document.getElementById("step3").classList.add("hidden");
    }
    if (this.state.page != 4) {
      document.getElementById("step4").classList.add("hidden");
    }
    if (this.state.page != 5) {
      document.getElementById("step5").classList.add("hidden");
    }
    if (this.state.page != 6) {
      document.getElementById("step6").classList.add("hidden");
    }
    if (this.state.page != 7) {
      document.getElementById("step7").classList.add("hidden");
    }
    if (this.state.page != 8) {
      document.getElementById("step8").classList.add("hidden");
    }
    if (this.state.page != 9) {
      document.getElementById("step9").classList.add("hidden");
    }
    if (this.state.page == 9) {
      document.getElementById("nxtPage").innerHTML = "<span>提交</span>";
    }
  };
  // 下一页
  pagePlus = () => {
    // 每页需要检查的数据
    let pageArr = [];
    if (this.state.page == 1) {
      var sort = this.state.userInfo.height;
      var r = /^\+?[1-9][0-9]*$/; //正整数
      var flag = r.test(sort);
      if (flag == false) {
        Toast.info("身高必须为正整数！", 1);
        return false;
      }
      var r = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/; //电子邮箱
      sort = this.state.userInfo.email;
      var flag = r.test(sort);
      if (flag == false) {
        Toast.info("电邮格式不正确！", 1);
        return false;
      }
      sort = this.state.userInfo.mobilephone;
      flag = judgePhone.test(sort);
      if (flag == false) {
        Toast.info("手机号码格式不正确！", 1);
        return false;
      }
      pageArr = [
        "name",
        // 'techTitle',
        "hasJob",
        "sex",
        "bloodType",
        // 'birthdate',
        "ID",
        "height",
        "weight",
        // 'job',
        "nativePlace",
        "naition",
        "religion",
        "hobby",
        // 'entryTime',
        "homeAddress",
        "homeDetailAddress",
        "homePhone",

        "address",
        "detailAddress",
        "phone",

        "mobilephone",
        "email",
      ];
    } else if (this.state.page == 6) {
      let pageArr5 = [
        "computer",
        "English",
        "microscope",
        "package",
        "welding",
        "autoTool",
        "assemble",
        "measure",
        "material",
        "chemi",
        "sight",
        "eyeIllness",
      ];
      let checkstr = "";
      let i = 0;
      var info = "";
      while (i < pageArr5.length) {
        checkstr = this.state.data5[pageArr5[i]] || "";
        if (checkstr.length == 0) {
          if (pageArr5[i] == "computer") {
            info = "计算机水平";
          } else if (pageArr5[i] == "English") {
            info = "英文水平";
          } else if (pageArr5[i] == "microscope") {
            info = "显微镜";
          } else if (pageArr5[i] == "package") {
            info = "组装";
          } else if (pageArr5[i] == "welding") {
            info = "焊接";
          } else if (pageArr5[i] == "autoTool") {
            info = "自动化机台";
          } else if (pageArr5[i] == "assemble") {
            info = "包装";
          } else if (pageArr5[i] == "measure") {
            info = "手动帖（夹）物料";
          } else if (pageArr5[i] == "material") {
            info = "目检";
          } else if (pageArr5[i] == "chemi") {
            info = "化学品使用";
          } else if (pageArr5[i] == "sight") {
            info = "近视度数";
          } else if (pageArr5[i] == "eyeIllness") {
            info = "眼科疾病";
          }
          Toast.info(info + "还没有填写", 1);
          return false;
        }
        i++;
      }
    } else if (this.state.page == 7) {
      let pageArr4 = [
        "chroDise",
        "health",
        "illness",
        "injury",
        "microscope",
        "suit",
      ];
      console.log(this.state.data4);
      let checkstr = "";
      let i = 0;
      let flagCheck = false;
      var info = "";

      while (i < pageArr4.length) {
        checkstr = this.state.data4[pageArr4[i]] || "";
        if (checkstr.length == 0) {
          if (pageArr4[i] == "microscope") {
            info = "显微镜";
          } else if (pageArr4[i] == "chroDise") {
            info = "慢性病";
          } else if (pageArr4[i] == "health") {
            info = "身体状况";
          } else if (pageArr4[i] == "illness") {
            info = "重大疾病";
          } else if (pageArr4[i] == "injury") {
            info = "工伤";
          } else if (pageArr4[i] == "suit") {
            info = "防尘/静电服";
          }
          Toast.info(info + "还没有填写", 1);
          return false;
        }
        i++;
      }
    } else if (this.state.page == 5) {
      pageArr = [
        "emergency",
        "emgRelation",
        "emgUnit",
        "emgJob",
        "emgDetailAddress",
        "emgAddress",
        "emgPhone",
      ];
    } else if (this.state.page == 2) {
      var n = 0;
      var flagToast = false;
      var jT = this.judgeTime(this.state.data);
      if (jT == false) {
        return false;
      }

      while (n < this.state.data.length) {
        var dataArr = this.state.data[n];
        for (var key in dataArr) {
          var comArr = [
            "startTime",
            "endTime",
            "school",
            "major",
            "schoolType",
            "eduBg",
            "eduCertificate",
          ];
          var i2 = 0;
          var flagIn = false;
          var info = "";
          var infoJ = "";
          while (i2 < comArr.length) {
            if (key == comArr[i2]) {
              flagIn = true;
              infoJ = comArr[i2];
            }
            i2++;
          }

          if (flagIn == true) {
            var l = dataArr[key] || "flagToast";

            if (l == "flagToast") {
              if (infoJ == "startTime") {
                info = "开始时间";
              } else if (infoJ == "endTime") {
                info = "结束时间";
              } else if (infoJ == "school") {
                info = "学校名称";
              } else if (infoJ == "major") {
                info = "专业";
              } else if (infoJ == "schoolType") {
                info = "教育类型";
              } else if (infoJ == "eduBg") {
                info = "学历程度";
              } else if (infoJ == "eduCertificate") {
                info = "是否有毕业证书";
              }
              Toast.info("第" + (n + 1) + "项的" + info + "还没有填写", 1);
              return false;
            }
          }
        }
        n++;
      }
    } else if (this.state.page == 3) {
      var n = 0;
      var flagToast = false;
      var jT = this.judgeTime(this.state.data2);
      if (jT == false) {
        return false;
      }
      while (n < this.state.data2.length) {
        var dataArr = this.state.data2[n];
        for (var key in dataArr) {
          var comArr = [
            "startTime",
            "endTime",
            "unit",
            "job",
            "quitReason",
            "quitType",
          ];
          var i2 = 0;
          var flagIn = false;
          while (i2 < comArr.length) {
            // if(key=='bossPhone'){
            // 	if(judgePhone.test(dataArr[key])==false){
            // 		Toast.info('上级手机号格式不正确！',1);
            // 		return false;
            // 	}
            // }//boss手机验证
            if (key == comArr[i2]) {
              flagIn = true;
            }
            i2++;
          }

          if (flagIn == true) {
            var l = dataArr[key] || "flagToast";
            if (l == "flagToast") {
              flagToast = true;
            }
          }
        }
        n++;
      }
      if (flagToast == true) {
        Toast.info(
          "您在本页还有消息未填写完。	没有工作经验或者以前是个体户的场合，时间与离职类别请任意填写，其余各项请填写“无”。",
          6
        );
        return false;
      }
    } else if (this.state.page == 4) {
      var n = 0;
      var flagToast = false;
      while (n < this.state.data3.length) {
        var dataArr = this.state.data3[n];
        var info = "";
        var infoJ = "";
        for (var key in dataArr) {
          var comArr = [
            "name",
            "relation",
            "unit",
            "job",
            "detailAddress",
            "address",
            "phone",
          ];
          var i2 = 0;
          var flagIn = false;
          while (i2 < comArr.length) {
            if (key == comArr[i2]) {
              flagIn = true;
              infoJ = comArr[i2];
            }
            i2++;
          }

          if (flagIn == true) {
            var l = dataArr[key] || "flagToast";
            if (l == "flagToast") {
              if (infoJ == "name") {
                info = "姓名";
              } else if (infoJ == "relation") {
                info = "关系";
              } else if (infoJ == "unit") {
                info = "工作单位";
              } else if (infoJ == "job") {
                info = "职务";
              } else if (infoJ == "detailAddress") {
                info = "家庭详址";
              } else if (infoJ == "address") {
                info = "家庭住址";
              } else if (infoJ == "phone") {
                info = "联系电话";
              }
              Toast.info("第" + (n + 1) + "项的" + info + "还没有填写", 1);
              return false;
            }
          }
        }
        n++;
      }
    } else if (this.state.page == 8) {
      if (this.state.userInfo.photoLInk.length == 0) {
        Toast.info("请上传照片", 1);
        return false;
      }
    } else if (this.state.page == 9) {
      if (this.state.trimmedDataURL.length > 0) {
        this.postData();
      } else {
        Toast.info("请签名", 1);
      }
    }
    // 判断信息是否填写完毕
    if (this.checkPage(pageArr) == false) {
      // Toast.info('您在本页还有消息未填写完',1);
      return false;
    }

    if (this.state.page < 9) {
      this.setState({ page: this.state.page + 1 }, this.pageShow);
    }
  };
  // 上一页
  pageMinus = () => {
    document.getElementById("nxtPage").innerHTML = "<span>下一页</span>";
    this.setState({ page: this.state.page - 1 }, this.pageShow);
  };
  // 增加教育经历
  addEdu = () => {
    let data = this.state.data;
    data.push({
      startTime: "",
      endTime: "",
      school: "",
      major: "",
      schoolType: "",
      eduBg: "",
      eduCertificate: "",
    });
    this.setState({ data });
    var top = document.getElementById("step2").scrollHeight;
    window.scrollTo(0, top);
  };

  // 删除教育经历
  delEdu = (index) => {
    let _index = index;
    alert("删除", "确认删除吗？", [
      { text: "取消", onPress: () => console.log("cancel") },
      {
        text: "确认",
        onPress: () => {
          Toast.success("删除成功", 1);
          this.removeEdu(_index);
          let data = this.state.data;
          if (_index == 0) {
            data.splice(0, 1);
          } else {
            data.splice(_index, _index);
          }
          this.setState({ data });
          localStorage.setItem("eduInfo", JSON.stringify(this.state.data));
        },
      },
    ]);
  };

  // 存储教育经历到本地
  saveEdu() {
    this.editInfoTime();
    localStorage.setItem("eduInfo", JSON.stringify(this.state.data));
  }

  // 增加职业经验
  addJob = () => {
    let data = this.state.data2;
    data.push({
      startTime: "",
      endTime: "",
      unit: "",
      job: "",
      boss: "",
      bossJob: "",
      bossPhone: "",
      quitReason: "",
      quitType: "",
    });
    this.setState({ data2: data });
    var top = document.getElementById("step3").scrollHeight;
    window.scrollTo(0, top);
  };

  // 删除职业经验
  delJob = (index) => {
    let _index = index;
    alert("删除", "确认删除吗？", [
      { text: "取消", onPress: () => console.log("cancel") },
      {
        text: "确认",
        onPress: () => {
          Toast.success("删除成功", 1);

          this.removeJob(_index);
          let data2 = this.state.data2;
          if (_index == 0) {
            data2.splice(0, 1);
          } else {
            data2.splice(_index, _index);
          }
          this.setState({ data2 });
          localStorage.setItem("workInfo", JSON.stringify(this.state.data2));
        },
      },
    ]);
  };
  saveWork() {
    this.editInfoTime();
    localStorage.setItem("workInfo", JSON.stringify(this.state.data2));
  }
  // 增加家庭关系
  addFam = () => {
    let data = this.state.data3;
    data.push({
      name: "",
      relation: "",
      unit: "",
      job: "",
      address: "",
      detailAddress: "",
      phone: "",
    });
    this.setState({ data3: data });
    var top = document.getElementById("step4").scrollHeight;
    window.scrollTo(0, top);
  };
  // 删除家庭关系
  delFam = (index) => {
    let _index = index;
    alert("删除", "确认删除吗？", [
      { text: "取消", onPress: () => console.log("cancel") },
      {
        text: "确认",
        onPress: () => {
          Toast.success("删除成功", 1);

          this.removeFam(_index);
          let data3 = this.state.data3;
          if (_index == 0) {
            data3.splice(0, 1);
          } else {
            data3.splice(_index, _index);
          }
          this.setState({ data3 });
          localStorage.setItem("famInfo", JSON.stringify(this.state.data3));
        },
      },
    ]);
  };
  // 保存家庭关系
  saveFam() {
    this.editInfoTime();
    localStorage.setItem("famInfo", JSON.stringify(this.state.data3));
  }

  onChange = async (files, type, index, column) => {
    if (type === "remove") {
      this.setState({ userInfo: { ...this.state.userInfo, photoLink: [] } });
      this.setState({
        [column]: [],
      });
    }
    if (type === "add" && files.length >= 1) {
      Toast.loading("上传中...", 0);
      const _type = files[0].file.type.split("/");
      let file;
      await lrz(files[0].file)
        .then(function(rst) {
          // 处理成功会执行
          // console.log(rst);
          file = rst;
        })
        .catch(function(err) {
          // 处理失败会执行
        })
        .always(function() {
          // 不管是成功失败，都会执行
        });
      console.log("files[0].file", files[0].file);
      file = file || files[0].file;
      console.log("file", file);
      this.uploadFile(
        file.file,
        `http://kingofdinner.realsun.me:1201/api/AliyunOss/PutOneImageObject?bucketname=nutritiontower&srctype=${
          _type[1]
        }`,
        "cloud"
      ).then(
        (result) => {
          this.setState({
            [column]: [{ url: result }],
            personInfo: { ...this.state.personinfo, [column]: result },
          });
          Toast.hide();
          let arrLink = [{ url: result, id: 1 }];
          this.setState(
            { userInfo: { ...this.state.userInfo, photoLInk: arrLink } },
            this.refreshLocal
          );
          localStorage.setItem("photoLink", result);
          Toast.hide();
        },
        (err) => {
          //图片上传异常！
          Toast.hide();

          Toast.fail(err.message);
        }
      );
    }
  };

  uploadFile = (file, url, mode) => {
    return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append("file", file, file.name);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", url);
      xhr.onload = () => {
        const data = JSON.parse(xhr.response);
        if (xhr.status === 200 && (data.error === 0 || data.error === "0")) {
          let imgUrl;
          if (mode === "local") {
            imgUrl = data.httpfilename;
          } else if (mode === "cloud") {
            imgUrl = data.data;
          }
          resolve(imgUrl);
        } else {
          reject(data);
        }
      };
      xhr.send(fd);
    });
  };
  // 存储其他信息到本地
  saveOthers() {
    this.editInfoTime();
    localStorage.setItem("otherInfo", JSON.stringify(this.state.data4));
  }
  // 存储其他信息到本地
  saveSelf() {
    this.editInfoTime();
    localStorage.setItem("selfInfo", JSON.stringify(this.state.data5));
  }

  onTabChange = (key) => {};
  render() {
    let { trimmedDataURL, isLoading, photoLInk } = this.state;
    const { files } = this.state;
    const { getFieldProps } = this.props.form;
    return isLoading ? (
      <ActivityIndicator
        toast
        text="正在生成..."
        animating={this.state.isLoading}
      />
    ) : (
      <div>
        <WXVoiceInput
          visible={this.state.voiceInputField}
          onTranslateConfirm={(v) => {
            this.passVocalValue(v, this.state.voicePlace, this.state.voiceKey);
          }}
          onClose={() => {
            this.setState({ voiceInputField: false });
          }}
        />
        <WXVoiceInput
          visible={this.state.voiceInputField2}
          onTranslateConfirm={(v) => {
            this.passVVGroup(
              v,
              this.state.voicePlace2,
              this.state.voiceKey2,
              this.state.voiceIndex
            );
          }}
          onClose={() => {
            this.setState({ voiceInputField2: false });
          }}
        />
        <GoBack />

        <div className="progress-bar">
          <div className="msg-wrap">
            <h3>填写进度</h3>
            <span>{this.state.page - 1}/8</span>
            <div className="bar">
              <div id="cur" />
            </div>
          </div>
        </div>
        <div className="buttonBg">
          <Button
            type="primary"
            inline
            disabled={this.state.page === 1}
            onClick={this.pageMinus}
          >
            上一页
          </Button>
          <Button type="primary" inline onClick={this.pagePlus} id="nxtPage">
            下一页
          </Button>
        </div>
        <div id="infoWrap">
          <div className="answersheet" id="step1">
            <div>
              <List renderHeader={() => "个人信息"}>
                <InputItem
                  placeholder="请输入姓名"
                  value={this.state.userInfo.name}
                  onBlur={this.fixIOSWXBug}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, name: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "name",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  姓名
                </InputItem>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "已离职", value: "已离职" },
                    { label: "在职", value: "在职" },
                  ]}
                  cols={1}
                  value={this.state.userInfo.hasJob}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, hasJob: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">在职状态</List.Item>
                </Picker>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "男", value: "男" },
                    { label: "女", value: "女" },
                  ]}
                  cols={1}
                  value={this.state.userInfo.sex}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, sex: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">性别</List.Item>
                </Picker>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "A", value: "A" },
                    { label: "B", value: "B" },
                    { label: "AB", value: "AB" },
                    { label: "O", value: "O" },
                    { label: "未知", value: "未知" },
                  ]}
                  cols={1}
                  value={this.state.userInfo.bloodType}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, bloodType: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">血型</List.Item>
                </Picker>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="身份证号（填错的场合请重新注册）"
                  disabled
                  value={this.state.userInfo.ID}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, ID: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  身份证号
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入工作年限"
                  value={this.state.userInfo.seniority}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, seniority: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "seniority",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  工作年限
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入身高（cm）"
                  value={this.state.userInfo.height}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, height: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "height",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  身高(cm)
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入体重（kg）"
                  value={this.state.userInfo.weight}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, weight: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "weight",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  体重(kg)
                </InputItem>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    {
                      value: "北京市",
                      label: "北京市",
                    },
                    {
                      value: "天津市",
                      label: "天津市",
                    },
                    {
                      value: "上海市",
                      label: "上海市",
                    },
                    {
                      value: "重庆市",
                      label: "重庆市",
                    },
                    {
                      value: "河北省",
                      label: "河北省",
                    },
                    {
                      value: "山西省",
                      label: "山西省",
                    },
                    {
                      value: "辽宁省",
                      label: "辽宁省",
                    },
                    {
                      value: "吉林省",
                      label: "吉林省",
                    },
                    {
                      value: "黑龙江省",
                      label: "黑龙江省",
                    },
                    {
                      value: "江苏省",
                      label: "江苏省",
                    },
                    {
                      value: "浙江省",
                      label: "浙江省",
                    },
                    {
                      value: "安徽省",
                      label: "安徽省",
                    },
                    {
                      value: "福建省",
                      label: "福建省",
                    },
                    {
                      value: "江西省",
                      label: "江西省",
                    },
                    {
                      value: "山东省",
                      label: "山东省",
                    },
                    {
                      value: "河南省",
                      label: "河南省",
                    },
                    {
                      value: "湖北省",
                      label: "湖北省",
                    },
                    {
                      value: "湖南省",
                      label: "湖南省",
                    },
                    {
                      value: "广东省",
                      label: "广东省",
                    },
                    {
                      value: "海南省",
                      label: "海南省",
                    },
                    {
                      value: "四川省",
                      label: "四川省",
                    },
                    {
                      value: "贵州省",
                      label: "贵州省",
                    },
                    {
                      value: "云南省",
                      label: "云南省",
                    },
                    {
                      value: "陕西省",
                      label: "陕西省",
                    },
                    {
                      value: "甘肃省",
                      label: "甘肃省",
                    },
                    {
                      value: "青海省",
                      label: "青海省",
                    },
                    {
                      value: "台湾省",
                      label: "台湾省",
                    },
                    {
                      value: "内蒙古自治区",
                      label: "内蒙古自治区",
                    },
                    {
                      value: "广西壮族自治区",
                      label: "广西壮族自治区",
                    },
                    {
                      value: "西藏自治区",
                      label: "西藏自治区",
                    },
                    {
                      value: "宁夏回族自治区",
                      label: "宁夏回族自治区",
                    },
                    {
                      value: "新疆维吾尔自治区",
                      label: "新疆维吾尔自治区",
                    },
                    {
                      value: "香港特别行政区",
                      label: "香港特别行政区",
                    },
                    {
                      value: "澳门特别行政区",
                      label: "澳门特别行政区",
                    },
                  ]}
                  cols={1}
                  value={this.state.userInfo.nativePlace}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, nativePlace: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">籍贯</List.Item>
                </Picker>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    {
                      value: "汉族",
                      label: "汉族",
                    },
                    {
                      value: "阿昌族",
                      label: "阿昌族",
                    },
                    {
                      value: "鄂温克族",
                      label: "鄂温克族",
                    },
                    {
                      value: "傈僳族",
                      label: "傈僳族",
                    },
                    {
                      value: "水族",
                      label: "水族",
                    },
                    {
                      value: "白族",
                      label: "白族",
                    },
                    {
                      value: "高山族",
                      label: "高山族",
                    },
                    {
                      value: "珞巴族",
                      label: "珞巴族",
                    },
                    {
                      value: "塔吉克族",
                      label: "塔吉克族",
                    },
                    {
                      value: "保安族",
                      label: "保安族",
                    },
                    {
                      value: "仡佬族",
                      label: "仡佬族",
                    },
                    {
                      value: "满族",
                      label: "满族",
                    },
                    {
                      value: "塔塔尔族",
                      label: "塔塔尔族",
                    },
                    {
                      value: "布朗族",
                      label: "布朗族",
                    },
                    {
                      value: "哈尼族",
                      label: "哈尼族",
                    },
                    {
                      value: "毛南族",
                      label: "毛南族",
                    },
                    {
                      value: "土家族",
                      label: "土家族",
                    },
                    {
                      value: "布依族",
                      label: "布依族",
                    },
                    {
                      value: "哈萨克族",
                      label: "哈萨克族",
                    },
                    {
                      value: "门巴族",
                      label: "门巴族",
                    },
                    {
                      value: "土族",
                      label: "土族",
                    },
                    {
                      value: "朝鲜族",
                      label: "朝鲜族",
                    },
                    {
                      value: "蒙古族",
                      label: "蒙古族",
                    },
                    {
                      value: "佤族",
                      label: "佤族",
                    },
                    {
                      value: "达斡尔族",
                      label: "达斡尔族",
                    },
                    {
                      value: "赫哲族",
                      label: "赫哲族",
                    },
                    {
                      value: "苗族",
                      label: "苗族",
                    },
                    {
                      value: "维吾尔族",
                      label: "维吾尔族",
                    },
                    {
                      value: "傣族",
                      label: "傣族",
                    },
                    {
                      value: "回族",
                      label: "回族",
                    },
                    {
                      value: "仫佬族",
                      label: "仫佬族",
                    },
                    {
                      value: "乌孜别克族",
                      label: "乌孜别克族",
                    },
                    {
                      value: "德昂族",
                      label: "德昂族",
                    },
                    {
                      value: "基诺族",
                      label: "基诺族",
                    },
                    {
                      value: "纳西族",
                      label: "纳西族",
                    },
                    {
                      value: "锡伯族",
                      label: "锡伯族",
                    },
                    {
                      value: "东乡族",
                      label: "东乡族",
                    },
                    {
                      value: "京族",
                      label: "京族",
                    },
                    {
                      value: "怒族",
                      label: "怒族",
                    },
                    {
                      value: "瑶族",
                      label: "瑶族",
                    },
                    {
                      value: "侗族",
                      label: "侗族",
                    },
                    {
                      value: "景颇族",
                      label: "景颇族",
                    },
                    {
                      value: "普米族",
                      label: "普米族",
                    },
                    {
                      value: "彝族",
                      label: "彝族",
                    },
                    {
                      value: "独龙族",
                      label: "独龙族",
                    },
                    {
                      value: "柯尔克孜族",
                      label: "柯尔克孜族",
                    },
                    {
                      value: "羌族",
                      label: "羌族",
                    },
                    {
                      value: "裕固族",
                      label: "裕固族",
                    },
                    {
                      value: "俄罗斯族",
                      label: "俄罗斯族",
                    },
                    {
                      value: "拉祜族",
                      label: "拉祜族",
                    },
                    {
                      value: "撒拉族",
                      label: "撒拉族",
                    },
                    {
                      value: "藏族",
                      label: "藏族",
                    },
                    {
                      value: "鄂伦春族",
                      label: "鄂伦春族",
                    },
                    {
                      value: "黎族",
                      label: "黎族",
                    },
                    {
                      value: "畲族",
                      label: "畲族",
                    },
                    {
                      value: "壮族",
                      label: "壮族",
                    },
                  ]}
                  cols={1}
                  value={this.state.userInfo.naition}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, naition: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">民族</List.Item>
                </Picker>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "无", value: "无" },
                    { label: "伊斯兰教", value: "伊斯兰教" },
                    { label: "佛教", value: "佛教" },
                    { label: "基督教", value: "基督教" },
                    { label: "其他", value: "其他" },
                  ]}
                  cols={1}
                  value={this.state.userInfo.religion}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, religion: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">宗教信仰</List.Item>
                </Picker>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入兴趣爱好"
                  value={this.state.userInfo.hobby}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, hobby: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "hobby",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  兴趣爱好
                </InputItem>
              </List>
              <List renderHeader={() => "联系方式"}>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  extra="请选择家庭住址"
                  data={this.state.district}
                  title="家庭住址"
                  {...getFieldProps("C3_597856873340", {
                    rules: [{ required: true }],
                  })}
                  value={this.state.userInfo.homeAddress}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, homeAddress: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">家庭住址</List.Item>
                </Picker>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入详细家庭住址"
                  value={this.state.userInfo.homeDetailAddress}
                  onChange={(v) => {
                    this.setState(
                      {
                        userInfo: {
                          ...this.state.userInfo,
                          homeDetailAddress: v,
                        },
                      },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "homeDetailAddress",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  家庭详址
                </InputItem>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入家庭电话"
                  value={this.state.userInfo.homePhone}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, homePhone: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "homePhone",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  家庭电话
                </InputItem>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  extra="请选择暂住地址"
                  data={this.state.district}
                  title="暂住地址"
                  {...getFieldProps("C3_597856873340", {
                    rules: [{ required: true }],
                  })}
                  value={this.state.userInfo.address}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, address: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">暂住住址</List.Item>
                </Picker>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入详细暂住地址"
                  value={this.state.userInfo.detailAddress}
                  onChange={(v) => {
                    this.setState(
                      {
                        userInfo: { ...this.state.userInfo, detailAddress: v },
                      },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "detailAddress",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  暂住详址
                </InputItem>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入暂住电话"
                  value={this.state.userInfo.phone}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, phone: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "phone",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  暂住电话
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入手机号码"
                  value={this.state.userInfo.mobilephone}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, mobilephone: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "mobilephone",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  手机号码
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入电子邮箱"
                  value={this.state.userInfo.email}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, email: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "email",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  电子邮箱
                </InputItem>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step2">
            <h4>
              学历信息（从最高学历开始）
              <Button type="ghost" size="small" inline onClick={this.addEdu}>
                新增学历
              </Button>
            </h4>
            <div>
              <List renderHeader={() => "学历信息"}>
                <ul>
                  {this.state.data.map((item, index) => {
                    return (
                      <li key={index}>
                        <h5>
                          <span>{index + 1}</span>
                          <Button
                            type="warning"
                            size="small"
                            disabled={this.state.data.length === 1}
                            inline
                            onClick={() => this.delEdu(index)}
                          >
                            删除
                          </Button>
                        </h5>
                        <DatePicker
                          onBlur={this.fixIOSWXBug}
                          mode="date"
                          title="开始日期"
                          extra="请选择"
                          minDate={new Date(-1270260000)}
                          value={
                            item.startTime ? new Date(item.startTime) : null
                          }
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].startTime = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                        >
                          <List.Item arrow="horizontal">开始日期</List.Item>
                        </DatePicker>
                        <DatePicker
                          onBlur={this.fixIOSWXBug}
                          mode="date"
                          title="结束日期"
                          minDate={new Date(-1270260000)}
                          extra="请选择"
                          value={item.endTime ? new Date(item.endTime) : null}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].endTime = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                        >
                          <List.Item arrow="horizontal">结束日期</List.Item>
                        </DatePicker>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入学校名称"
                          value={item.school}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].school = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data",
                                  voiceKey2: "school",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          学校名称
                        </InputItem>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入专业"
                          value={item.major}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].major = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data",
                                  voiceKey2: "major",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          专业
                        </InputItem>
                        <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "成人/自考", value: "成人/自考" },
                            { label: "统招", value: "统招" },
                          ]}
                          cols={1}
                          value={item.schoolType}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].schoolType = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                        >
                          <List.Item arrow="horizontal">教育类型</List.Item>
                        </Picker>

                        <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "本科", value: "本科" },
                            { label: "大专", value: "大专" },
                            { label: "高中", value: "高中" },
                            { label: "中专", value: "中专" },
                            { label: "初中", value: "初中" },
                            { label: "研究生或以上", value: "研究生或以上" },
                            { label: "其他", value: "其他" },
                          ]}
                          cols={1}
                          value={item.eduBg}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].eduBg = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                        >
                          <List.Item arrow="horizontal">学历程度</List.Item>
                        </Picker>

                        <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            { label: "是", value: "是" },
                            { label: "否", value: "否" },
                          ]}
                          cols={1}
                          value={item.eduCertificate}
                          onChange={(value) => {
                            let data = this.state.data;
                            data[index].eduCertificate = value;
                            this.setState({ data: data }, this.saveEdu);
                          }}
                        >
                          <List.Item arrow="horizontal">
                            是否有毕业证书
                          </List.Item>
                        </Picker>
                      </li>
                    );
                  })}
                </ul>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step3">
            <h4>
              工作经验
              <Button type="ghost" size="small" inline onClick={this.addJob}>
                新增工作经验
              </Button>
            </h4>
            <div>
              <List renderHeader={() => "工作经验"}>
                <ul>
                  {this.state.data2.map((item, index) => {
                    return (
                      <li key={index}>
                        <h5>
                          <span>{index + 1}</span>
                          <Button
                            type="warning"
                            size="small"
                            disabled={this.state.data2.length === 1}
                            inline
                            onClick={() => this.delJob(index)}
                          >
                            删除
                          </Button>
                        </h5>

                        <DatePicker
                          onBlur={this.fixIOSWXBug}
                          mode="date"
                          title="开始日期"
                          extra="请选择"
                          value={
                            item.startTime ? new Date(item.startTime) : null
                          }
                          minDate={new Date(-1270260000)}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].startTime = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                        >
                          <List.Item arrow="horizontal">开始日期</List.Item>
                        </DatePicker>
                        <DatePicker
                          onBlur={this.fixIOSWXBug}
                          mode="date"
                          title="结束日期"
                          extra="请选择"
                          value={item.endTime ? new Date(item.endTime) : null}
                          minDate={new Date(-1270260000)}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].endTime = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                        >
                          <List.Item arrow="horizontal">结束日期</List.Item>
                        </DatePicker>

                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入工作单位"
                          value={item.unit}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].unit = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data2",
                                  voiceKey2: "unit",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          工作单位
                        </InputItem>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          value={item.job}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].job = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                          placeholder="请输入担任职务"
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data2",
                                  voiceKey2: "job",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          担任职务
                        </InputItem>

                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入离职原因"
                          value={item.quitReason}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].quitReason = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data2",
                                  voiceKey2: "quitReason",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          离职原因
                        </InputItem>
                        <Picker
                          onBlur={this.fixIOSWXBug}
                          data={[
                            {
                              label: "因个人原因主动离职",
                              value: "因个人原因主动离职",
                            },
                            {
                              label: "因违法违纪被开除",
                              value: "因违法违纪被开除",
                            },
                            {
                              label: "协商解除/终止劳动合同",
                              value: "协商解除/终止劳动合同",
                            },
                          ]}
                          cols={1}
                          value={item.quitType}
                          onChange={(value) => {
                            let data = this.state.data2;
                            data[index].quitType = value;
                            this.setState({ data2: data }, this.saveWork);
                          }}
                        >
                          <List.Item arrow="horizontal">离职类别</List.Item>
                        </Picker>
                      </li>
                    );
                  })}
                </ul>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step4">
            <h4>
              家庭关系
              <Button type="ghost" size="small" inline onClick={this.addFam}>
                新增家庭关系
              </Button>
            </h4>
            <div>
              <List renderHeader={() => "家庭关系"}>
                <ul>
                  {this.state.data3.map((item, index) => {
                    return (
                      <li key={index}>
                        <h5>
                          <span>{index + 1}</span>
                          <Button
                            type="warning"
                            size="small"
                            disabled={this.state.data3.length === 1}
                            inline
                            onClick={() => this.delFam(index)}
                          >
                            删除
                          </Button>
                        </h5>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入姓名"
                          value={item.name}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].name = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "name",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          姓名
                        </InputItem>

                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入关系"
                          value={item.relation}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].relation = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "relation",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          关系
                        </InputItem>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入工作单位"
                          value={item.unit}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].unit = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "unit",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          工作单位
                        </InputItem>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入职务"
                          value={item.job}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].job = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "job",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          职务
                        </InputItem>
                        <Picker
                          onBlur={this.fixIOSWXBug}
                          extra="请选择家庭住址"
                          data={this.state.district}
                          title="家庭住址"
                          {...getFieldProps("C3_597856873340", {
                            rules: [{ required: true }],
                          })}
                          value={item.address}
                          onChange={(v) => {
                            let data = this.state.data3;
                            data[index].address = v;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                        >
                          <List.Item arrow="horizontal">家庭住址</List.Item>
                        </Picker>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入详细家庭地址"
                          value={item.detailAddress}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].detailAddress = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "detailAddress",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          家庭详址
                        </InputItem>
                        <InputItem
                          onBlur={this.fixIOSWXBug}
                          placeholder="请输入联系电话"
                          value={item.phone}
                          onChange={(value) => {
                            let data = this.state.data3;
                            data[index].phone = value;
                            this.setState({ data3: data }, this.saveFam);
                          }}
                          extra={
                            <img
                              src={mic}
                              className="mic"
                              onClick={() =>
                                this.setState({
                                  voiceInputField2: true,
                                  voicePlace2: "data3",
                                  voiceKey2: "phone",
                                  voiceIndex: index,
                                })
                              }
                            />
                          }
                        >
                          联系电话
                        </InputItem>
                      </li>
                    );
                  })}
                </ul>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step5">
            <div>
              <List renderHeader={() => "紧急联系人"}>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入姓名"
                  value={this.state.userInfo.emergency}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emergency: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emergency",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  姓名
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入关系"
                  value={this.state.userInfo.emgRelation}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emgRelation: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emgRelation",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  关系
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入工作单位"
                  value={this.state.userInfo.emgUnit}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emgUnit: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emgUnit",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  工作单位
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入职务"
                  value={this.state.userInfo.emgJob}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emgJob: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emgJob",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  职务
                </InputItem>

                <Picker
                  extra="请选择家庭地址"
                  onBlur={this.fixIOSWXBug}
                  data={this.state.district}
                  title="家庭地址"
                  {...getFieldProps("C3_597856873340", {
                    rules: [{ required: true }],
                  })}
                  value={this.state.userInfo.emgAddress}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emgAddress: v } },
                      this.refreshLocal
                    );
                  }}
                >
                  <List.Item arrow="horizontal">家庭地址</List.Item>
                </Picker>

                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入详细家庭地址"
                  value={this.state.userInfo.emgDetailAddress}
                  onChange={(v) => {
                    this.setState(
                      {
                        userInfo: {
                          ...this.state.userInfo,
                          emgDetailAddress: v,
                        },
                      },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emgDetailAddress",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  家庭详址
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="请输入联系电话"
                  value={this.state.userInfo.emgPhone}
                  onChange={(v) => {
                    this.setState(
                      { userInfo: { ...this.state.userInfo, emgPhone: v } },
                      this.refreshLocal
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "emgPhone",
                          voiceKey: "userInfo",
                        })
                      }
                    />
                  }
                >
                  联系电话
                </InputItem>
              </List>
            </div>
          </div>
          <div className="answersheet hidden" id="step6">
            <div>
              <List renderHeader={() => "能力指标自我评价"}>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.computer}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, computer: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">计算机水平</List.Item>
                </Picker>
                <p>
                  熟练使用键盘和鼠标,可熟练借助word或其他软件编辑文字,可利用表格进行数据统计.
                </p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.English}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, English: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">英文水平</List.Item>
                </Picker>
                <p>
                  可读写26个英文字母,对于日常工作中接触频繁的英文单词可记忆并使用.
                </p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.microscope}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, microscope: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">显微镜</List.Item>
                </Picker>
                <p>有显微镜工作经验,并不排斥在工作时使用显微镜.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.assemble}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, assemble: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">组装</List.Item>
                </Picker>
                <p>有组装/装配工作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.welding}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, welding: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">焊接</List.Item>
                </Picker>
                <p>有使用烙铁焊接PCB板的工作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.autoTool}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, autoTool: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">自动化机台</List.Item>
                </Picker>
                <p>有使用自动化机台&机台电脑造作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.package}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, package: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">包装</List.Item>
                </Picker>
                <p>有电子产品包装工作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.material}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, material: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">手动贴(夹)物料</List.Item>
                </Picker>
                <p>有手动贴(夹)物料的工作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.measure}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, measure: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">目检</List.Item>
                </Picker>
                <p>有产品目检的工作经验.</p>

                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "熟练", value: "熟练" },
                    { label: "一般", value: "一般" },
                    { label: "不熟练", value: "不熟练" },
                  ]}
                  cols={1}
                  value={this.state.data5.chemi}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, chemi: v } },
                      this.saveSelf
                    );
                  }}
                >
                  <List.Item arrow="horizontal">化学品使用</List.Item>
                </Picker>
                <p>有化学品使用经验,不排斥在有化学品的环境中工作.</p>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="目前是无眼科疾病的状态请填写‘无’"
                  value={this.state.data5.eyeIllness}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, eyeIllness: v } },
                      this.saveSelf
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "eyeIllness",
                          voiceKey: "data5",
                        })
                      }
                    />
                  }
                >
                  眼科疾病
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="目前是视力正常的状态请填写‘0’"
                  value={this.state.data5.sight}
                  onChange={(v) => {
                    this.setState(
                      { data5: { ...this.state.data5, sight: v } },
                      this.saveSelf
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "sight",
                          voiceKey: "data5",
                        })
                      }
                    />
                  }
                >
                  近视度数
                </InputItem>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step7">
            <div>
              <List renderHeader={() => "其他信息"}>
                <Picker
                  onBlur={this.fixIOSWXBug}
                  data={[
                    { label: "健康", value: "健康" },
                    { label: "亚健康", value: "亚健康" },
                    { label: "不健康", value: "不健康" },
                  ]}
                  cols={1}
                  value={this.state.data4.health}
                  onChange={(v) => {
                    this.setState(
                      { data4: { ...this.state.data4, health: v } },
                      this.saveOthers
                    );
                  }}
                >
                  <List.Item arrow="horizontal">身体状况</List.Item>
                </Picker>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="目前是无重大疾病的状态请填写‘无’"
                  value={this.state.data4.illness}
                  onChange={(v) => {
                    this.setState(
                      { data4: { ...this.state.data4, illness: v } },
                      this.saveOthers
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "illness",
                          voiceKey: "data4",
                        })
                      }
                    />
                  }
                >
                  重大疾病
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="目前是无工伤的状态请填写‘无’"
                  value={this.state.data4.injury}
                  onChange={(v) => {
                    this.setState(
                      { data4: { ...this.state.data4, injury: v } },
                      this.saveOthers
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "injury",
                          voiceKey: "data4",
                        })
                      }
                    />
                  }
                >
                  工伤
                </InputItem>
                <InputItem
                  onBlur={this.fixIOSWXBug}
                  placeholder="目前是无慢性病的状态请填写‘无’"
                  value={this.state.data4.chroDise}
                  onChange={(v) => {
                    this.setState(
                      { data4: { ...this.state.data4, chroDise: v } },
                      this.saveOthers
                    );
                  }}
                  extra={
                    <img
                      src={mic}
                      className="mic"
                      onClick={() =>
                        this.setState({
                          voiceInputField: true,
                          voicePlace: "chroDise",
                          voiceKey: "data4",
                        })
                      }
                    />
                  }
                >
                  慢性病
                </InputItem>

                <Flex.Item>
                  <Radio
                    className="my-radio"
                    checked={this.state.data4.microscope || false}
                    onChange={(v) => {
                      this.setState(
                        { data4: { ...this.state.data4, microscope: true } },
                        this.saveOthers
                      );
                    }}
                  >
                    我愿意看显微镜
                  </Radio>
                </Flex.Item>

                <Flex.Item>
                  <Radio
                    className="my-radio"
                    checked={this.state.data4.suit || false}
                    onChange={(v) => {
                      this.setState(
                        { data4: { ...this.state.data4, suit: true } },
                        this.saveOthers
                      );
                    }}
                  >
                    我愿意穿防尘服/静电服
                  </Radio>
                </Flex.Item>
              </List>
            </div>
          </div>

          <div className="answersheet hidden" id="step8">
            <div>
              <List renderHeader={() => "上传正面免冠照片"}>
                <div className="photo">
                  <ImagePicker
                    files={photoLInk}
                    onChange={(files, type, index) =>
                      this.onChange(files, type, index, "photoLInk")
                    }
                    onImageClick={(index, fs) => console.log(index, fs)}
                    selectable={photoLInk.length < 1}
                    accept="image/*"
                  />
                </div>
              </List>
            </div>
          </div>
          <div className="answersheet hidden" id="step9">
            <div>
              <div className="insurance-success">
                <div className="qianming" ref="sig">
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      width: 200,
                      height: 200,
                      className: "sigCanvas",
                    }}
                    ref={(ref) => {
                      this.sigCanvas = ref;
                    }}
                  />
                </div>
                <div id="previewImg" onClick={this.enlarge} />
                <span className="hint">* 请逐字填写姓名</span>
                <Button
                  type="default"
                  inline
                  size="small"
                  id="delOne"
                  onClick={this.clear}
                >
                  删除最后一位
                </Button>
                <Button
                  type="default"
                  inline
                  size="small"
                  id="delAll"
                  onClick={this.clearAll}
                >
                  删除全部
                </Button>

                <button className="buttons hidden" onClick={this.trim} id="add">
                  添加
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(createForm()(EditPersonalInfo));
// ReactDOM.render(<EditPersonalInfo />, mountNode);
